import { documentSlice } from 'cdx-common';
import React, { useEffect } from 'react';
import { appStore } from './../../store';


export const Persistor = () => {
    return <><OnlineLookup /></>;
};

const OnlineLookup = () => {

    const changeOnline = React.useCallback(() => {
        appStore.dispatch(documentSlice.actions.setOnLine(navigator.onLine));
    }, []);

    useEffect(() => {
        changeOnline();
        window.addEventListener("online", changeOnline);
        window.addEventListener("offline", changeOnline);
        return () => {
            window.removeEventListener("online", changeOnline);
            window.removeEventListener("offline", changeOnline);
        };
    }, []);

    return <></>;
};
